// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"72190039","228":"aa6a48ff","271":"7a6993ed","552":"72190039","872":"45dd1dfe","960":"3fbc9e87"}[chunkId] + ".chunk.css";
};